import { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { Loader } from 'src/components/common/Loader';
import { RelevanceTestDefinitionDetails } from 'src/components/RelevanceTestDefinitionDetails';

const RelevanceTestDefinitionDetailsPage = (): JSX.Element => {
    const { testDefinitionId } = useParams();

    return (
        <Suspense fallback={<Loader />}>
            <RelevanceTestDefinitionDetails testDefinitionId={testDefinitionId ?? 'Foo'} />
        </Suspense>
    );
};

// eslint-disable-next-line import/no-default-export
export default RelevanceTestDefinitionDetailsPage;
